//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionError from "./section-error";
import { validationMixin } from "vuelidate";
import { validDate } from "@Shared/@Utils/validation-rules";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import MaterialInput from "../inputs/material-input.vue";
import { isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DateSection",
  components: {
    SectionError,
    DatepickerInput,
    MaterialInput
  },
  mixins: [validationMixin],
  validations: {
    value: {
      validDate
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    datepickerOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    label: {
      type: String,
      default: null
    },
    init: {
      type: Boolean,
      default: true
    },
    calendar: {
      type: Boolean,
      default: true
    },
    fullMode: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: ""
    },
    labelFor: {
      type: String,
      default: ""
    },
    maturityDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      labelValue: isEmpty(this.labelFor) ? uuidv4() : this.labelFor
    };
  },
  computed: {
    isValidDate() {
      return !this.$v.$invalid;
    }
  },
  methods: {
    handleChange(value) {
      const valueToEmit = this.isValidDate ? value : "";
      this.$emit("change", valueToEmit);
    }
  }
});